import { Grid, Layout, theme } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import { Suspense, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { OfficeTicketDetailProvider } from 'src/contexts/officeTicketDetail.context';
import ConfirmLogSidebar from 'src/pages/v2/HrTicket/components/ConfirmLogSidebar';
import HandoverTicketDetail from 'src/pages/v2/OfficeTicket/HandoverTicketDetail';

const { useBreakpoint } = Grid;

const OfficeTicketDetailLayout = () => {
  const { isDetailSidebarCollapsed, isTicketDetailCollapsed } = useContext(AppContext);
  const screens = useBreakpoint();
  const location = useLocation();
  const {
    token: { colorBgContainer }
  } = theme.useToken();

  const renderOfficeTicketDetail = () => {
    if (location.pathname.includes(urlPath.handoverTicket.location)) {
      return <HandoverTicketDetail />;
    }
  };

  return (
    <Sider
      className='ticket-detail-layout'
      trigger={null}
      width={`calc(100% - ${screens.xxl ? '400px' : '320px'})`}
      collapsible
      collapsed={isTicketDetailCollapsed}
      style={{ background: colorBgContainer }}
      collapsedWidth={0}
    >
      <Layout hasSider>
        <OfficeTicketDetailProvider>
          <Content>
            <Suspense>{renderOfficeTicketDetail()}</Suspense>
          </Content>
          <Sider
            trigger={null}
            width={screens.xxl ? '400px' : '320px'}
            collapsible
            collapsed={isDetailSidebarCollapsed}
            style={{ background: colorBgContainer }}
            collapsedWidth={50}
          >
            <ConfirmLogSidebar />
          </Sider>
        </OfficeTicketDetailProvider>
      </Layout>
    </Sider>
  );
};

export default OfficeTicketDetailLayout;
